import { KuposDatePicker, KuposSelectBox } from '../../../common';
import React, { useRef, useState } from 'react';

import DateService from '../../../../services/dateService';
import getIcons from '../../functions/getIcons/getIcons';
import i18next from 'i18next';

const SearchInput = props => {
	const { t, home, actions, history, operator } = props.data;
	const errorInitialState = {
		source: '',
		destination: '',
		date: '',
	};
	// console.log("Operator Name is => ", operator.operator_name)
	const [error, setError] = useState(errorInitialState);
	const destinationRef = useRef({});

	const onSourceChange = value => {
		setError({ ...error, source: null });
		actions.pbSetSourceCity(value);
		getOriginSelectedFilteredDestinations(home.uniqueCities, home.pbSourceCity);

		if (home.pbDestinationCity && value.value === home.pbDestinationCity.value) {
			onDestinationChange(null);
		}

		destinationRef.current.onMenuOpen();
		destinationRef.current.select.focus();
	};

	const onDestinationChange = value => {
		setError({ ...error, destination: null });
		actions.pbSetDestinationCity(value);
	};

	const getOriginSelectedFilteredDestinations = (rawArray, itemToRemove) => {
		if (rawArray && itemToRemove) {
			return rawArray
				.map(function (obj) {
					if (obj.label == itemToRemove.label) {
					} else {
						return obj;
					}
				})
				.filter(function (obj) {
					return typeof obj !== 'undefined';
				});
		} else if (!itemToRemove) {
			// return rawArray;
		}
	};

	const search = e => {
		e.preventDefault();
		if (props.is_mot) {
			props.data.actions.setIsMot(true);
		}
		if (!home.pbSourceCity) {
			setError({ ...error, source: 'VALIDATIONS.VALID_ORIGIN_CITY' });
			return;
		} else if (!home.pbDestinationCity) {
			setError({ ...error, destination: 'VALIDATIONS.VALID_DESTINATION_CITY' });
			return;
		} else {
			let source = home.pbSourceCity.label
				.toLowerCase()
				.replace(/-/g, '_')
				.replace(/ /g, '-')
				.replace(/_/g, '--');
			let dest = home.pbDestinationCity.label
				.toLowerCase()
				.replace(/-/g, '_')
				.replace(/ /g, '-')
				.replace(/_/g, '--');
			actions.setServiceListOnward(null);
			if (!home.returnPBDate) {
				history.push(
					`/${i18next.language}/${i18next.language == 'es' ? 'pasajes-bus' : 'bus-tickets'
					}/${source}/${dest}/${home.onwardPBDate ? home.onwardPBDate : DateService.getTodayString()
					}`,
				);
			} else {
				history.push(
					`/${i18next.language}/${i18next.language == 'es' ? 'pasajes-bus' : 'bus-tickets'
					}/${source}/${dest}/${home.onwardPBDate}/${home.returnPBDate}/1`,
				);
			}
		}
	};

	// console.log(props);

	return (
		<form onSubmit={search}>
			<div className="home-selection-input-boxes">
				<div className="home-selection-input-box font10">
					{/* <span className="label font11 bold-text">{t('HOME.ORIGIN')}</span> */}
					<span className={operator && operator.operator_name === "pullmandelsur" ? "label font11 bold-text" : "label font11"}>{t('HOME.ORIGIN')}</span>
					<KuposSelectBox
						reactSelect
						selectType="origin"
						options={home.uniqueCities ? home.uniqueCities : []}
						selectedOption={home.pbSourceCity}
						onChange={onSourceChange}
						// onInputChange={this.onInputChange}
						// placeholder={'Source'}
						icon={getIcons('Origin', operator)}
						hideArrow={true}
						error={error.source ? true : false}
						errorMessage={t(error.source)}
						// placeholder={t('HOME.ORIGIN')}
						placeholder={operator && operator.operator_name === "pullmandelsur" ? "Ciudad de Origen" : t('HOME.ORIGIN')}
						height={40}
						t={t}
					/>
				</div>

				<div className="home-selection-input-box font10">
					{/* <span className="label font11">{t('HOME.DESTINATION')}</span> */}
					<span className={operator && operator.operator_name === "pullmandelsur" ? "label font11 bold-text" : "label font11"}>{t('HOME.DESTINATION')}</span>

					<KuposSelectBox
						reactSelect
						selectType="destination"
						selectRef={destinationRef}
						options={
							home.pbSourceCity
								? getOriginSelectedFilteredDestinations(home.uniqueCities, home.pbSourceCity)
								: []
						}
						selectedOption={home.pbDestinationCity}
						onChange={onDestinationChange}
						// onInputChange={this.onInputChange2}
						// placeholder={'Destination'}
						icon={getIcons('Destination', operator)}
						hideArrow={true}
						error={error.destination ? true : false}
						errorMessage={t(error.destination)}
						// placeholder={t('HOME.DESTINATION')}
						placeholder={operator && operator.operator_name === "pullmandelsur" ? "Ciudad de Destino" : t('HOME.DESTINATION')}
						height={40}
						t={t}
					/>
				</div>

				<div className="home-selection-input-box font10 datebox">
					{/* <span className="label font11">{t('HOME.ONE_WAY')}</span> */}
					{/* <span className={operator && operator.operator_name === "pullmandelsur" ? "label font11 bold-text" : "label font11"}>{t('HOME.ONE_WAY')}</span> */}
					<span className={operator && operator.operator_name === "pullmandelsur" ? "label font11 bold-text" : "label font11"}>
						{operator && operator.operator_name === "pullmandelsur" ? "Fecha de viaje" : t('HOME.ONE_WAY')}
					</span>

					<KuposDatePicker
						selectedDate={home.onwardPBDate ? home.onwardPBDate : DateService.getTodayString()}
						onDateChange={date => {
							actions.setOnwardPbDate(date);
							date > home.returnPBDate ? actions.setReturnPbDate(date) : null;
						}}
						minDate={DateService.getTodayString()}
						error={error.date ? true : false}
						errorMessage={error.date}
						placeholder={t('HOME.SELECT_DATE')}
						t={t}
					/>
				</div>
				{!props.is_mot && (
					<div className="home-selection-input-box font10 datebox">
						{/* <span className="label font11">{t('HOME.ROUND_TRIP')}</span> */}
						<span className={operator && operator.operator_name === "pullmandelsur" ? "label font11 bold-text" : "label font11"}>{t('HOME.ROUND_TRIP')}</span>

						<KuposDatePicker
							selectedDate={home.returnPBDate}
							onDateChange={date => actions.setReturnPbDate(date)}
							minDate={home.onwardPBDate}
							placeholder={t('HOME.OPTIONAL_DATE')}
							// error={this.state.dateErrorReturn ? true : false}
							// errorMessage={this.state.dateErrorReturn}
							canEraseDate={true}
							t={t}
						/>
						{home.returnPBDate && (
							<img
								className="pointer"
								onClick={() => actions.setReturnPbDate('')}
								src={'/static/images/icons/cross.png'}
								alt=""
								style={{
									width: 12,
									height: 12,
									resizeMode: 'contain',
									position: 'absolute',
									right: 7,
									bottom: 18,
								}}
							/>
						)}
					</div>
				)}


				<div className="home-selection-input-box font12 datebox">
					<button
						style={{
							background:
								operator && operator.color_codes && operator.color_codes.button_color
									? operator.color_codes.button_color
									: '',
						}}
						className="kupos-button home-selection-input-button "
						// onClick={search}
						type="submit"
					>
						<img src={getIcons('Search', operator)} alt="" style={{ height: 30 }} />
						<span>{t('HOME.SEARCH')}</span>
					</button>
				</div>
			</div>
			<div class="font10 new-pnr"></div>

		</form>
	);
};


export default SearchInput


// WEBPACK FOOTER //
// ./src/features/themes/ThemeTen/components/search-input.js